import React, { useState } from "react";
import "./hamburgerMenu.css";

function HamburgerMenu(props: any) {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => {
    setIsOpen(!isOpen);
    if (props.onClick) {
      props.onClick();
    }
  };

  return (
    <div
      className={`HamburgerMenu ${isOpen ? "open" : ""}`}
      onClick={handleClick}
    >
      <div className="line"></div>
      <div className="line"></div>
      <div className="line"></div>
    </div>
  );
}

export default HamburgerMenu;
